export const API_URLS = {
  login: 'usuarios/login',
  usuarios: '/usuarios',
  refreshToken: '/Usuarios/refresh-token',

  pedidos: '/pedidos',
  procesos: '/BlockedProcesses',
  listaProcesos: '/BlockedProcesses/procesos-catalogo',
  archivos: '/BlockedFiles',
  bloquearProceso: `/BlockedProcesses/block`,
  desbloquearProceso: `/BlockedProcesses/unblock`,
  bloquearFile: `/BlockedFiles/block`,
  desbloquearFile: `/BlockedFiles/unblock`,
  nuevoFile: `/BlockedFiles/nuevoFile`,
  verificaArchivo: `/BlockedFiles/verificar-archivo`,
  archivados: `/BlockedFiles/archivados`,
  archivar: `BlockedFiles/archivar`,
  getSalesOrders :`/SalesOrders/resumen`,
  getSalesOrdersDet :`/SalesOrders/detalle`,
  detalleTraduccion: 'SalesOrders/getSalesOrdersDet',
  PedidoExt:`pedido/salesStatusByDate`,
  SalesPedido:`pedido/salesStatusByDate`, 
  PedidoFecha:`Pedido/pedidos`,
  enviaMaximos:`MaxCustomerProduct/upload`,
  resultados:`Results`,
  roles:`Roles`,
  GuardaRoles:`Roles`,
  ListaRoles: 'Roles',         
  ListaPermisos: 'Permisos',
  ActualizaRol: `Roles/update`,
  ActualizaPermisos: 'Permisos/save',
  ListaUsuarios : 'Usuarios',
  updateUsuario: 'Usuarios/update',
  deleteUser: (id) => `Usuarios/delete/${id}`,
  getProfile: 'Auth/perfil',
  EliminaRol: (id) => `Roles/${id}`,
  detallePedido: (id) => `Pedido/detalle/${id}`,
  HistoriaProceso:(id) =>`BlockedProcesses/Historial/${id}`,
  uploadFile:`Upload/upload`, 
  ListFiles:`Upload/list`,
  deleteFile: (id) => `Upload/delete/${id}`,
  FileProcesa: (id) => `Upload/procesar/${id}`,
  listaLogs: 'Logs',
  detalleLog: 'Logs/detalle',
  updateUsuarioMarketplace: 'Usuarios/updateMarketplace',
  listaprocesosUser: (id) => `Usuarios/procesos/${id}`,
  reprocesarArchivo:'SalesOrders/reprocesar-archivo',

  // Resumen dashboard
  resumenVentasHoy:'ResumenDashboard/ventas-hoy',


};
